module.exports = __webpack_public_path__ + "static/media/arrow-icon.c676b308.svg";